import * as React from 'react'
// import { Link } from 'react-router-dom'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import MUILink from "@mui/material/Link";
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const LinkButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ theme, color }) => ({
  fontWeight: 500,
  margin: '0px 0px',
  background: 'transparent',
  color: color ? color : theme.palette.primary.main,
  overflow: 'hidden',
  display: 'inline',
  padding: '0px 0px',
  fontSize: 'inherit',
  verticalAlign: 'baseline',
  lineHeight: 'inherit',
  minWidth: 0,
  overflowWrap: 'anywhere',
  textTransform:'unset', 
  [theme.breakpoints.down('md')]: {
    display: 'contents',    
  },
  '&:before': {
    content: `" "`,
    position: 'absolute',
    transition: 'transform 0.3s ease',
    left: 0,
    bottom: 0,
    width: '100%',
    height: '2px',
    background: color ? color : theme.palette.primary.main,
    transform: 'translateX(-100%)',
  },
  '& .MuiTouchRipple-root': {
    padding: 0
  },
  '&:hover': {
    background: 'transparent',
    '&:before': {
      transform: 'translateX(0)'
    },
  }

}));
// export function CGLinkButton(props) {
//   let color = props.color ? props.color : null;
//   let target = props.target? props.target : '_self'
//   return (
//     <Link {...props} style={{ ...props.style,textDecoration: 'none', fontSize: 'inherit' }}>
//       <LinkButton color={color}>{props.children}</LinkButton>
//     </Link>    
//   );
// }

export function CGLinkButton2(props) {
  let color = props.color ? props.color : null;
  return (    
      <LinkButton  {...props} color={color}>{props.children}</LinkButton>
 
  );
}

export function CGRedirectButton(props) {
  let color = props.color ? props.color : null;
  return (
    <MUILink {...props} style={{ textDecoration: 'none', fontSize: 'inherit' }}>
      <LinkButton color={color}>{props.children}</LinkButton>
    </MUILink>
  );

}
export function CGTooltip(props) {
  return (
    <Tooltip title={props.title} arrow placement="top">
      <Box sx={{ display: 'inline' }}>
        {props.children}
      </Box>
    </Tooltip>
  );

}